import { useEffect, useState } from "react";
import { useMedia, YStack } from "@medbillai/ui";
import { CASES_PANEL_WIDTH, useCasesPanel } from "../../../provider/cases-panel";
import { IssueEventsProvider } from "../../../provider/issue-events";
import { CasesScreen } from "../../cases/screen";
const TRANSITION_MS = 200;
export const CasesSlidePanel = () => {
  const {
    isOpen,
    togglePanel,
    isOnCasesPage,
    showRead,
    showUnread,
    showClosed,
    setFilters
  } = useCasesPanel();
  const media = useMedia();
  // The CSS animation driver can't handle exit animations when enterStyle === exitStyle,
  // so we use state-driven transitions instead of AnimatePresence and defer the content
  // unmount manually to keep it visible during the slide-out.
  const mounted = useDeferredUnmount(isOpen, TRANSITION_MS);

  // Suppress on case pages (inline panel is used instead)
  if (isOnCasesPage) {
    return null;
  }

  // Only show on desktop screens
  if (!media.gtSm) {
    return null;
  }
  return <>
      <YStack position="absolute" top={0} left={0} right={0} bottom={0} onPress={isOpen ? () => togglePanel("overlay_dismiss", false) : undefined} zIndex="$5" opacity={isOpen ? 1 : 0} style={{
      pointerEvents: isOpen ? "auto" : "none"
    }} transition={`${TRANSITION_MS}ms`} cursor="pointer" data-sentry-element="YStack" data-sentry-source-file="CasesSlidePanel.web.tsx" />
      <YStack position="absolute" top={0} left={0} bottom={0} width={CASES_PANEL_WIDTH} borderRightWidth={1} borderRightColor="$strokeSecondary" backgroundColor="$background" zIndex="$modal" x={isOpen ? 0 : -CASES_PANEL_WIDTH} style={{
      pointerEvents: isOpen ? "auto" : "none"
    }} transition={`${TRANSITION_MS}ms`} overflow="hidden" shadow="light" data-sentry-element="YStack" data-sentry-source-file="CasesSlidePanel.web.tsx">
        {mounted ? <IssueEventsProvider>
            <CasesScreen filterState={{
          showRead,
          showUnread,
          showClosed,
          setFilters
        }} source="cases_slide_panel" />
          </IssueEventsProvider> : null}
      </YStack>
    </>;
};
function useDeferredUnmount(active: boolean, delayMs: number): boolean {
  const [mounted, setMounted] = useState(active);
  useEffect(() => {
    if (active) {
      setMounted(true);
      return;
    }
    const id = setTimeout(() => setMounted(false), delayMs);
    return () => clearTimeout(id);
  }, [active, delayMs]);
  return mounted;
}